
import React, { useState, useEffect } from 'react';
import * as FitterHelper from '../library/FitterHelper';
import { Locale } from '../classes/Locale';
import setupPdfEN from '../images/SetupInstructions.pdf';
import setupPdfJP from '../images/SetupInstructionsJapanese.pdf';
import setupPdfFR from '../images/SetupInstructionsFrench.pdf';

export default function SetupInstructions() {
    const [pdfFile, setPdfFile] = useState(null);

    useEffect(() => {
        const asyncProcess = async() => {
            let fitter = await FitterHelper.getFitter();
            switch (fitter.locale){
                case Locale.frenchCanadian:
                case Locale.french:
                    setPdfFile(setupPdfFR);
                    break;
                case Locale.japanese:
                    setPdfFile(setupPdfJP);
                    break;
                default:
                    setPdfFile(setupPdfEN);
                    break;
            }
        }
        asyncProcess();
    })

    return (
        <>
            <iframe src={pdfFile + "#toolbar=0"} width="100%" height="99%"></iframe>
        </>
    )
}